/** Informações adicionais Abbott (modal Dados do evento → planilha exclusiva). */
export interface AbbottAdditionalInfo {
  contractId: string;
  cventCode: string;
  observations: string;
  terrestrialCoordinator: string;
  terrestrialPhone: string;
  terrestrialEmail: string;
  aerialCoordinator: string;
  aerialPhone: string;
  aerialEmail: string;
}

export const emptyAbbottAdditionalInfo = (): AbbottAdditionalInfo => ({
  contractId: "",
  cventCode: "",
  observations: "",
  terrestrialCoordinator: "",
  terrestrialPhone: "",
  terrestrialEmail: "",
  aerialCoordinator: "",
  aerialPhone: "",
  aerialEmail: "",
});
